<template>
  <div>
    <div id="heads" class="heads">
      <div class="headers-wrapper">
        <div class="headers-left">
          <div class="logo-wrapper" @click="goHome(getLocationSiteCityId)">
            <img
              :src="
                basicInfo.logo ? basicInfo.logo : '../../assets/logo-litter.png'
              "
              alt
            />
          </div>
          <div class="nav-wrapper tel-out">
            <div class="tel">
              <div class="tel-top">服务热线 {{ basicInfo.serviceTime }}</div>
              <div class="tel-bottom">{{ loactionCityPhone }}</div>
            </div>
          </div>
            <div class="location-box">
              <div class="location" :class="activeIndex == '1' ? 'location-active' : ''">
                <img src="../../assets/svg/location.svg" alt="" />
                <el-select
                  v-model="location"
                  placeholder="请选择"
                  @visible-change="locationChange($event, location)"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in siteCityList"
                    :key="item.cityId"
                    :label="item.cityName"
                    :value="item.cityId"  
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="location-bottom"
                :class="activeIndex == '1' ? 'location-select' : ''"
              >
                {{ locationDescription }}
              </div>
            </div>
        </div>
        <div class="nav-wrapper nav-wrapper2">
          <el-menu
            class="el-menu-demo"
            mode="horizontal"
            text-color="#222"
            :index="activeIndex"
            @select="noHome()"
          >
            <router-link to="/teamBuilding" class="nav-text">
              <el-menu-item
                index="2"
                :class="[
                  path == 'teamBuilding' || path == 'teamBuilding'
                    ? 'active'
                    : '',
                ]"
                ><div class="team-building">团建<div class="hot">热门</div></div>
               
                </el-menu-item
              >
            </router-link>
            <router-link to="/themeList" class="nav-text">
              <el-menu-item
                index="2"
                :class="[
                  path == 'themeList' || path == 'themeList'
                    ? 'active'
                    : '',
                ]"
                >主题
                </el-menu-item
              >
            </router-link>
            <router-link to="/internalTrainingList" class="nav-text">
              <el-menu-item
                index="3"
                :class="[
                  path == 'internalTrainingList' ||
                  path == 'internalTrainingList'
                    ? 'active'
                    : '',
                ]"
                >内训</el-menu-item
              >
            </router-link>
            <router-link to="/annualMeetingPage" class="nav-text">
              <el-menu-item
                index="4"
                :class="[
                  path == 'annualMeetingPage' || path == 'annualMeetingPage'
                    ? 'active'
                    : '',
                ]"
                >年会</el-menu-item
              >
            </router-link>
            <router-link to="/caseList" class="nav-text">
              <el-menu-item
                index="5"
                :class="[
                  path == 'caseList' || path == 'caseList' ? 'active' : '',
                ]"
                >案例</el-menu-item
              >
            </router-link>
            <router-link to="/cooperation" class="nav-text">
              <el-menu-item
                index="6"
                :class="[
                  path == 'cooperation' || path == 'cooperation'
                    ? 'active'
                    : '',
                ]"
                >合作</el-menu-item
              >
            </router-link>
            <router-link to="/aboutUs" class="nav-text">
              <el-menu-item
                index="7"
                :class="[
                  path == 'aboutUs' || path == 'aboutUs' ? 'active' : '',
                ]"
                >关于我们</el-menu-item
              >
            </router-link>
          </el-menu>
        </div>
        <div></div>
        <div></div>
        <div></div>
        <!-- <div class="booking">
          <div class="left"></div>
          <div class="right">
            <span style="transform: scale(1)">免费定制方案</span>
          </div>
        </div> -->
        <!-- <div class="user-wrapper">
        <div class="user-center" v-if="isLogin">
          <img class="user-img"  @click="goUerCenter" :src="this.$store.state.memberInfo.headPic"/>
        </div>
        <div class="user-btn" v-else>
          <span class="fa fa-user fa-lg"></span>
          <router-link to="/login">登录&nbsp;&nbsp;/</router-link>
          <router-link to="/registered">&nbsp;&nbsp;注册</router-link>
        </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "heads",
  data() {
    return {
      activeIndex: "",
      path: "",
      // 服务热线
      servicePhone: "13172094444",
      // 服务时间
      serviceTime: "09:00-13:00",
      // 地点
      location: "",
      locationDescription: "",
      siteCityList: [],
      preLocation: "",
    };
  },
  components: {},
  computed: {
    getSiteCityList() {
      return this.$store.state.siteCityList;
    },
    getLocationSiteCityId(){
     return this.$store.state.locationSiteCity;
    },
    loactionCityPhone() {
      return this.$store.state.locationCityPhone?this.$store.state.locationCityPhone:this.$store.state.webInfo.servicePhone;
    },
    basicInfo() {
      return this.$store.state.webInfo;
    },
  },
  methods: {
    //  handlePicPlusPre,
    locationChange(callback, val) {
      if (!callback) {
        // console.log("this.preLocation")
        // console.log(this.preLocation)
        // console.log(this.location)
        // console.log(this.path)
        if (this.preLocation == this.location && this.path == "home") {
          return;
        }
        this.activeIndex = "/page";
        // console.log(this.location);
        this.$store.commit("saveLocationSiteCity", val);
        this.getSiteCityList.forEach(siteCity=>{
          if(siteCity.cityId==this.location){
            this.$store.commit("saveLocationCityPhone", siteCity.cityPhone)
          }
        })
        // console.log(this.$store.state.locationSiteCity);
        this.preLocation = this.location;
        this.path = "home";
        window.location.href = "/home?location=" + this.location;
      }
      console.log("go");
    },
    goHome(val) {
      if (val) {
        window.location.href = "/home?location=" + val;
      }
      console.log("go");
    },
    locationLoad() {
      console.log("shijiao");
      // this.preLocation = this.location
      // this.path = 'home'
      // window.location.href = '/home?location='+this.location;
    },
    noHome() {
      this.activeIndex = "";
      console.log(this.activeIndex);
      console.log("非首页");
    },
  },

  watch: {
    //监听value的变化，进行相应的操做便可
    getSiteCityList: {
      //a是value的新值，b是旧值
      handler(nval, oval) {
        this.siteCityList = nval;
      },
    },
    getLocationSiteCityId: {
      //a是value的新值，b是旧值
      handler(nval, oval) {
        if ((this.preLocation = "")) {
          this.location = nval;
          this.preLocation = nval;
        }
      },
    },
    deep: true, // 深度监听
    immediate: true, //立即执行
  },
  mounted() {
    this.siteCityList = this.getSiteCityList;
    console.log("this.getSiteCityList");
    console.log(this.getSiteCityList);
    console.log(this.loactionCityPhone);
    this.path = this.$route.name;
    if (this.path == "home") {
      this.activeIndex = "1";
    }
    this.$nextTick(()=>{
      this.location = this.$store.state.locationSiteCity ;
      this.preLocation = this.location;
    })
    console.log(this.location);
    // var reg = new RegExp("(^|&)location=([^&]*)(&|$)","i");
    // var location = window.location.search.substr(1).match(reg);

    // if (location) {
    //   this.location =location[2];
    //   if(typeof(this.location)!='Number'){
    //     this.location = Number(this.location)
    //   }
    // }
    console.log("this.siteCityList[this.location-1].cityName");
    // console.log(this.siteCityList[this.location-1].cityName)
    console.log(this.siteCityList.length);
    if (this.siteCityList && this.siteCityList.length > 0) {
      this.siteCityList.forEach(siteCity => {
        if(siteCity.cityId == this.location){
          this.locationDescription = siteCity.cityName
        }
      });
    }
  },
  created() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dio {
  text-align: left;
}
.dio-content {
  width: 100%;
  border-top: 1px solid #cccccc;
}
.dio-con {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.qr-wrapper {
  margin: 0 30px;
  line-height: 50px;
}
.qr-wrapper img {
  margin: 0 auto;
  display: block;
  width: 150px;
  height: 150px;
}
.dio-bottom {
  text-align: center;
  color: #757575;
  line-height: 30px;
}
.dio-phone {
  color: #017842;
  cursor: pointer;
}
.dio-phone:hover {
  font-weight: bold;
}
.container {
  font-weight: 700;
  display: flex;
  justify-content: space-between;
  /*font-size: 16px !important;*/
}
.heads {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #eee;
  background: #fff;
  z-index: 2000;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 17%);
}
.sptext {
  font-size: 12px;
}
.headers-wrapper {
  display: flex;
  position: relative;
  margin: 0 auto;
  width: 1060px;
  height: 100%;
  /* justify-content: space-between; */
}


.name {
  width: 100px;
}
.nav-wrapper {
  padding: 0 15px;
  display: flex;
}
.user-wrapper {
  width: 100px;
}
.user-center {
  margin: 6px auto;
  width: 50px;
  height: 50px;
}
.user-center > .user-img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  box-shadow: 0 0 4px #999;
  /*border: 1px solid #999;*/
}
.user-img:hover {
  cursor: pointer;
}
.user-btn {
  background: #409eff;
  background-image: linear-gradient(to right, #409eff 0%, #e92758 100%);
  width: 120px;
  height: 35px;
  line-height: 35px;
  border-radius: 30px;
  font-size: 14px;
  text-align: center;
  margin-top: 15px;
}
.user-btn span {
  color: #fff;
  line-height: 5px;
}
.user-btn a {
  color: #fff;
}
.el-menu--horizontal > .el-menu-item.is-active,
.el-submenu.is-active,
.active {
  /* background: #007741 !important; */
  color: #359ff8 !important;
  font-weight: 700;
  border-bottom: 4px solid #359ff8 !important;
}
.active-text {
  color: #fff;
}
.active-text:hover {
  color: #222;
}
.is-opened .active-text {
  color: #222 !important;
}
.nav-text {
  display: inline-block;
  float: left;
  height: 60px;
  line-height: 60px;
}
.el-menu-item {
  height: 60px;
  line-height: 60px;
}
.active .el-submenu__title i {
  color: #fff !important;
}
.el-menu-item {
  font-size: 14px !important;
}
.el-submenu__title > a {
  font-size: 16px !important;
}
.el-menu-item > a {
  display: block;
  width: 100%;
  height: 100%;
}
li a {
  /*color: #fff;*/
}
.nav-wrapper >>> .el-menu{
  background-color: #0000;
}
.nav-wrapper >>> .el-menu.el-menu--horizontal {
  border: none;
}
.location-active >>> .el-select .el-input__inner, .location-active >>> .el-select__caret{
  color: #359ff8 !important;
}
@media screen and (min-width: 1920px) {
  /* .container {
    width: 1400px;
  }

  .logo-wrapper {
    width: 180px;
  }
  .logo-wrapper img {
    height: 60px;
    vertical-align: middle;
  }
  .user-btn {
    width: 150px;
    height: 50px;
    line-height: 50px;
    border-radius: 50px;
    font-size: 12px;
    text-align: center;
    margin-top: 5px;
  }
  .nav-text {
    height: 100px;
    line-height: 100px;
  }
  .el-menu-item {
    height: 100px !important;
    line-height: 100px !important;
  }
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 100px !important;
    line-height: 100px !important;
  } */
}
</style>
<style>
.is-opened,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.el-menu-item:hover {
  /* background: #60f0af !important; */
  color: #359ff8 !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover a {
  color: #333 !important;
}
.active .el-submenu__title i {
  color: #fff !important;
}
@media screen and (min-width: 1560px) {
  .container {
    width: 1400px;
  }
}
.dio .el-dialog__title {
  font-size: 14px !important;
  font-weight: bold;
}
.dio .el-dialog__body {
  padding: 0px 20px !important;
}
.nav-login .el-menu-item.is-active {
  color: #000;
}

.booking {
  width: 175px;
  height: 61px;
  background: #359ff8;
  /* color:rgb(12, 81, 102); */
  flex-direction: row;
  flex-wrap: nowrap;
  display: flex;
  position: fixed;
  right: 0;
  box-shadow: inset 0 1px 10px 0 rgb(12, 81, 102/ 69%);
}
.booking .left {
  width: 50px;
  border-bottom-right-radius: 60px;
  background: #fff;
}
.booking .right {
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  padding-left: 10px;
  cursor: pointer;
}
.booking .right span {
  display: inline-block;
  padding: 0 1px;
}
/* 站点 start */
.location {
  padding-right: 10px;
  display: flex;
  height: 59px;
  box-sizing: border-box;
  /* margin-bottom: 5px; */
}
.location-box {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.location img {
  text-align: center;
  width: 20px;
}
.location .el-input__inner {
  border: none;
  border-color: transparent;
  width: 100px;
  color: #000;
  font-weight: 700;
  text-align: center;
}
/* 站点 end */
.tel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
  padding-right: 10px;
  padding-left: 10px;
}
.tel .tel-top {
  line-height: 30px;
  font-size: 12px;
  color: #666;
  line-height: 20px;
}
.tel .tel-bottom {
  line-height: 30px;
  font-size: 16px;
  color: #222;
  line-height: 20px;
  font-family: Arial-Black;
}
.headers-left {
  display: flex;
}
.location-select {
  border-bottom: 4px solid #359ff8;
  margin: 0px 38px;
  position: relative;
  left: -1px;
}
.location-bottom {
  height: 1px;
  box-sizing: border-box;
  position: relative;
  top:-3px;
  z-index: -100;
  font-size: 12px;
  color: transparent;
}
.headers-wrapper .tel-out{
  position: absolute;
  left: 90px;
  top:10px
}
.headers-wrapper .location-box {
  position: absolute;
  right: 510px;
  top: 0px;
}
.nav-wrapper2{
  position: absolute;
  right: 0px;
  top: 0px;
}
.logo-wrapper {
  width: 96px;
  /* padding-left: 60px; */
  position: absolute;
  left: 0px;
  cursor: pointer;
}
.logo-wrapper img {
  width: 100%;
  /* height: 40px; */
  vertical-align: middle;
}
 .team-building{
  position: relative;
 } 
 .team-building .hot{
    background-image: linear-gradient(90deg,#fe6387,#f92f21);
    border-radius: 30px 30px 30px 0;
    position: absolute;
    width: 31px;
    height: 14px;
    font-size: 10px;
    line-height: 14px;
    color: #fff;
    top: 6px;
    left: 15px;
 } 
</style>




// WEBPACK FOOTER //
// src/components/comment/heads.vue